var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewAllSpreads = function SvgViewAllSpreads(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 7a2 2 0 0 1 2-2h5v10h-7zM12.5 5h7v10h-7zM21.5 5h5a2 2 0 0 1 2 2v8h-7zM3.5 17h7v10h-5a2 2 0 0 1-2-2zM12.5 17h7v10h-7zM21.5 17h7v8a2 2 0 0 1-2 2h-5z"
  })));
};
export default SvgViewAllSpreads;